import React from "react";

const MaterialForm = () => {
  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          Product Entry Form
        </div>

        <div className="card-body">
          <form>

            {/* Date */}
            <div className="mb-3">
              <label className="form-label">Date</label>
              <input type="date" className="form-control" />
            </div>

            {/* Product Category */}
            <div className="mb-3">
              <label className="form-label">Product Category</label>
              <select className="form-select">
                <option value="">Select Category</option>
                <option>Cement</option>
                <option>Steel</option>
                <option>Bricks</option>
                <option>Sand</option>
                <option>Tiles</option>
                <option>Electrical</option>
              </select>
            </div>

            {/* Product Name */}
            <div className="mb-3">
              <label className="form-label">Product Name</label>
              <input type="text" className="form-control" />
            </div>

            {/* Quantity */}
            <div className="mb-3">
              <label className="form-label">Product Quantity</label>
              <input type="number" className="form-control" />
            </div>

            {/* Cost */}
            <div className="mb-3">
              <label className="form-label">Product Cost (Per Unit)</label>
              <input type="number" className="form-control" />
            </div>

            {/* Remark */}
            <div className="mb-3">
              <label className="form-label">Remark</label>
              <textarea className="form-control" rows="3"></textarea>
            </div>

            {/* Amount Paid */}
            <div className="mb-3">
              <label className="form-label">Product Amount Paid</label>
              <input type="number" className="form-control" />
            </div>

            {/* Payment Method */}
            <div className="mb-3">
              <label className="form-label">Payment Method</label>
              <select className="form-select">
                <option value="">Select Payment Method</option>
                <option>Cash</option>
                <option>UPI</option>
                <option>Bank Transfer</option>
                <option>Cheque</option>
                <option>Credit Card</option>
              </select>
            </div>

            {/* Invoice Upload */}
            <div className="mb-3">
              <label className="form-label">Upload Invoice</label>
              <input
                type="file"
                className="form-control"
                multiple
              />
              <div className="form-text">
                You can upload multiple invoice files.
              </div>
            </div>

            {/* Submit Button */}
            <div className="d-grid">
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default MaterialForm;